import { Box, Divider, Typography } from '@vp/swan';
import React from 'react';
import { getFormattedTime } from './src-utils-miaw-common.js';
import './src-components-ConversationEvent-ConversationEvent.styles.scss.js';

const ConversationEvent = ({ eventDetails, timeStamp, paddingX, width }) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { paddingY: 6, style: width ? { width } : {}, paddingX, compactMode: true }, /* @__PURE__ */ React.createElement(Divider, { marginBottom: 2 }), /* @__PURE__ */ React.createElement(Typography, { fontSize: "small", textColor: "subtle", textAlign: "center" }, eventDetails, " \xB7 ", getFormattedTime(timeStamp))));
};

export { ConversationEvent as default };
//# sourceMappingURL=src-components-ConversationEvent-ConversationEvent.js.map
